import { createSlice } from '@reduxjs/toolkit'

import { fetchAvailableAddons } from './actions/fetch_available_addons'

const availableAddonsSlice = createSlice({
  name: 'availableAddons',
  initialState: {
    error: null,
    initialized: false,
    content: null
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAvailableAddons.pending, (state) => {
      state.initialized = false
      state.error = null
    })
    builder.addCase(fetchAvailableAddons.fulfilled, (state, action) => {
      state.initialized = true
      state.error = null
      state.content = action.payload
    })
    builder.addCase(fetchAvailableAddons.rejected, (state, action) => {
      state.initialized = true
      state.error = action.payload
    })
  }
})

export const { reducer } = availableAddonsSlice
